export enum SuitabilityRoutes {
  DOMICILE = "domicile",
  TERMS = "terms",
}
